import React from 'react';
import { Modal, Button, Table } from 'react-bootstrap';
import { FaCheck, FaTimes, FaExclamation, FaBatteryFull } from 'react-icons/fa';

const DeviceDetailsModal = ({ show, onHide, dualSense }) => {
  if (!dualSense) return null;

  // Parse testTracking if it's a string
  const parsedTestTracking = dualSense.testTracking 
    ? typeof dualSense.testTracking === 'string' 
      ? JSON.parse(dualSense.testTracking) 
      : dualSense.testTracking
    : null;

  const getStatusMessage = (status, isStepOne) => {
    if (isStepOne) {
      if (status) {
        return <span style={{ color: 'red' }}>Failed <FaTimes style={{ color: 'red' }} /></span>;
      } else {
        return <span style={{ color: 'green' }}>Passed <FaCheck style={{ color: 'green' }} /></span>;
      }
    } else {
      if (status === true) {
        return <span style={{ color: 'green' }}>Passed <FaCheck style={{ color: 'green' }} /></span>;
      } else if (status === false) {
        return <span style={{ color: 'red' }}>Failed <FaTimes style={{ color: 'red' }} /></span>;
      } else {
        return <span style={{ color: 'orange' }}>Unknown <FaExclamation style={{ color: 'orange' }} /></span>;
      }
    }
  };

  const renderDetails = (details, step) => {
    if (!details || typeof details !== 'object') {
      return (
        <tr>
          <td colSpan="2">No detailed information available</td>
        </tr>
      );
    }

    return Object.entries(details).map(([component, status]) => (
      <tr key={component}>
        <td>{component.replace(/([A-Z])/g, ' $1').replace(/\b\w/g, l => l.toUpperCase())}</td>
        <td>{getStatusMessage(status, step === 'stepOne')}</td>
      </tr>
    ));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>
          <i className="bi bi-controller me-2"></i>
          Device Details - {dualSense.realSerialNumber || dualSense.deviceSerialNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="mb-4">
          <h5 className="fw-bold mb-3">Basic Information</h5>
          <Table striped bordered hover className="mb-0">
            <tbody>
              <tr>
                <th width="280px">Status</th>
                <td>
                  <span className={`badge ${dualSense.globalStatus === 'OK' ? 'bg-success' : 'bg-danger'}`}>
                    {dualSense.globalStatus}
                  </span>
                </td>
              </tr>
              <tr>
                <th>Start Date</th>
                <td>{dualSense.startDate ? new Date(dualSense.startDate).toLocaleString() : 'N/A'}</td>
              </tr>
              <tr>
                <th>Duration</th>
                <td>{dualSense.duration ? `${dualSense.duration} seconds` : 'N/A'}</td>
              </tr>
              <tr>
                <th>Tester Name</th>
                <td>{dualSense.raspberry_id || 'N/A'}</td>
              </tr>
              <tr>
                <th>Symptom Description</th>
                <td>{dualSense.symptome_description || 'N/A'}</td>
              </tr>
              {parsedTestTracking?.batteryLevel !== undefined && (
                <tr className={dualSense.globalStatus === 'KO' ? 'table-danger' : 'table-success'}>
                  <th>
                    <FaBatteryFull className="me-2" />
                    Battery level
                  </th>
                  <td>{parsedTestTracking.batteryLevel}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {dualSense.globalStatus === "KO" && parsedTestTracking && (
          <div className="mt-4">
            <h5 className="fw-bold mb-3">Test Tracking Results</h5>
            {parsedTestTracking.failureStep && (
              <div className="alert alert-danger mb-4">
                <FaExclamation className="me-2" />
                <strong>Failure detected in:</strong> {parsedTestTracking.failureStep}
              </div>
            )}
            
            {Object.entries(parsedTestTracking)
              .filter(([key]) => !['batteryLevel', 'failureStep'].includes(key))
              .map(([step, details]) => (
                <div key={step} className="mb-4 tracking-step">
                  <h6 className="fw-bold">
                    {step.split(/(?=[A-Z])/).join(' ').toUpperCase()}
                  </h6>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th width="280px">Component</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderDetails(details, step)}
                    </tbody>
                  </Table>
                </div>
              ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeviceDetailsModal;